import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//https://material-ui.com/components/progress/

import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import logger from '../utils/logger';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = logger.createLogger('LinearProgressWithLabel');
export function LinearProgressWithLabel(props) {
  log.debug({
    'progress': props.value
  }, 'LinearProgressWithLabel');
  return /*#__PURE__*/_jsxs(Box, {
    display: "flex",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(Box, {
      width: "100%",
      mr: 1,
      children: /*#__PURE__*/_jsx(LinearProgress, _objectSpread({
        variant: "determinate"
      }, props))
    }), /*#__PURE__*/_jsx(Box, {
      minWidth: 35,
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "body2",
        color: "textSecondary",
        children: "".concat(Math.round(props.value), "%")
      })
    })]
  });
}
LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired
};